<template>
  <div>
    <el-row :gutter="20" class="top-block">
      <Breadcrumb :route="this.$route"></Breadcrumb>
    </el-row>
      <!-------------------------------------------------------------------->
      <!-- action -->
      <!-------------------------------------------------------------------->

    <el-row v-if="!editTask">   
      <el-col :xs="8" :sm="8" :lg="8">
          <el-button type="normal" @click.prevent="goBack" class="ml-20" circle><i class="el-icon-d-arrow-left"></i>
          </el-button>
        </el-col>
        <el-col :xs="16" :sm="16" :lg="16" style="text-align: right">
        <el-button v-if="canEdit" type="warning" @click.prevent="handleDraft">暫存 <i
            class="el-icon-s-claim"></i></el-button>
        <el-button v-if="canEdit" type="primary" @click.prevent="handleSign" class="mr-20">送簽核 <i
            class="el-icon-s-claim"></i></el-button>
      </el-col>
    </el-row>

      <!-------------------------------------------------------------------->
      <!-- form -->
      <!-------------------------------------------------------------------->


      <!--    基本資料-->
    <el-row v-if="!editTask">  
      <BasicInfo :basicForm="basicForm" :canEdit="canEdit"></BasicInfo>
    </el-row>

      

      <!-------------------------------------------------------------------->
      <!-- table -->
      <!-------------------------------------------------------------------->

      <!--    工作項目資料-->
      <el-row v-if="!editTask">
      <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
        <el-main class="taskMain">
         <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>工作日報</span>
            <el-button v-if="canEdit" style="float: right; padding: 5px 12px" 　type="primary"
                       @click.prevent="handleAddTask" class="mr-20" id="add_task_btn">新增工作日報 <i class="el-icon-s-claim"></i></el-button>
          </div>
          <div>

            <PaintingTask :canEdit="canEdit" ref="paintingTaskChild" :dw="dw" @childClickEdit="handleEdit"></PaintingTask>


          </div>
        </el-card>
        </el-main>
      </el-col>
    </el-row>

    <!--    簽核紀錄-->
    <SignOffHistory :editTask="editTask" :canViewSignOff="canViewSignOff"></SignOffHistory>

    

      <!-------------------------------------------------------------------->
      <!-- dialog -->
      <!-------------------------------------------------------------------->

     <el-row v-if="editTask" style="background-color: white; padding:20px">
      
        <el-form class="myform" label-position="top"
               :model="form"
               :rules="dailyJobRule"
               ref="painting_daily_form"
               label-width="100px" id="add_task_form">

        <el-row>
          <el-col :xs="24" :sm="24" :md="12">
            <el-form-item label="商品" prop="product" style="width: 100%;">
              <el-autocomplete
              class="inline-input full-width-input"
              :items="form.defaultItem"
              auto-select-first
              v-model="form.product"
              :fetch-suggestions="querySearch"
              placeholder="輸入商品名稱"
              :trigger-on-focus="false"
              @select="handleSelect"
              ></el-autocomplete>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="效果" prop="checkList">
              <el-checkbox-group v-model="form.checkList"  >
                <el-checkbox v-for="(task,idx) in task.paintingTypeOptions" 
                :key="task.id"
                :label="task.name"
                @change="changeEffect"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="效果說明" prop="resultNotes">
              <el-input type="textarea" rows="4" v-model="form.resultNotes" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :xs="24" :sm="24" :md="12">
            <el-form-item label="數量" prop="qty">
              <el-input-number v-model="form.qty" :min="1" :max="100"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="進度" prop="progress">
              <el-select v-model="form.progress" placeholder="Select">
                <el-option
                  v-for="item in progressOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="花費時長" prop="timeHour">
                <el-input-number v-model="form.timeHour"  :min="0" :max="40"></el-input-number> 小時
            </el-form-item>
            <el-form-item label="" prop="timeMinute">
                <el-input-number v-model="form.timeMinute"  :min="0" :max="60" class="mt-10"></el-input-number> 分鐘
            </el-form-item>
            
          </el-col>
        </el-row>


        <FileUpload :fileNotes="form.fileNotes" :fileList="form.fileList"></FileUpload>

      </el-form>

      <div  style="float: right;" class="mt-20">
        <el-button @click="cancelAddTask">取 消</el-button>
        <el-button type="primary" @click="saveTask('painting_daily_form')">確 定</el-button>
      </div>

       
    </el-row>
     
  </div>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import PaintingTask from "@/components/task/painting-task";
import FileUpload from "@/components/task/file-upload";
import SignOffHistory from '@/components/signoff/sign-history'
import BasicInfo from '@/components/task/basic-info'
import {mapState} from 'vuex'
import debounce from 'lodash/debounce'
import dayjs from "dayjs";


export default {
  name: "PaintingDaily",
  components: {
    Breadcrumb, PaintingTask, SignOffHistory, BasicInfo, FileUpload
  },
  data() {
    let checkName = (rule, value, callback) => {
      if (value === '' || value === null || typeof value === 'undefined') {
        callback(new Error('請輸入資料'))
      } else {
        callback()
      }
    }
    let treeCheck = (rule, value, callback) => {
      let selectedIds = this.$refs.tree.getCheckedKeys();

      if (!selectedIds || selectedIds.length === 0) {
        callback(new Error('請確認出勤前工作'))
      } else {
        callback()
      }
    }

    return {
      editTask: false,
      
      

      props: {
        label: 'name'
      },
      historyTableData: [],
      precheckListOption: [],

      progressOptions:[
        {value: '10%', label: '10%'},
        {value: '20%', label: '20%'},
        {value: '30%', label: '30%'},
        {value: '40%', label: '40%'},
        {value: '50%', label: '50%'},
        {value: '60%', label: '60%'},
        {value: '70%', label: '70%'},
        {value: '80%', label: '80%'},
        {value: '90%', label: '90%'},
        {value: '100%', label: '100%'}
      ],

      basicForm: {
        id: '',
        title: '',
        startDate: '',
        userObj: {
          username:''
        },
        status:'',
        endDate: '',
        preCheckItem: '',
        preCheckTree:[],
        visitRoute: ''
      },

      visitForm: {
        customerId: '',
        arrivalTime: '',
        deliveryContent: [],
        serviceContent: [],
        paymentReceive: [],
        notes: '',
        fileList: []
      },

      task: {
        tableData:[],
        dialog: false,
        form: {
          mytodoId: '',
          id:'',
          fileList:[],
          fileNotes:[]
        },
        btnCount:0,
        taskTypeOptions:[],
        paintingTypeOptions:[]
      },

      loading: false,
      dw: '40%',
      fileList: [],
      preCheckOption: [],
      precheckList: [],
      tableData: [],
      options: [],
      queryField: '',
      keyword: '',
      pageNum: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      formLabelWidth: '',
      deliveryContentOptions: ['送店', '指送'],
      shippingToDifferentAddress: false,
      serviceContentOptions: ['補目錄', '做宣傳', '交流','收退料', '放帳單'],
      paymentReceiveOptions: ['現金', '期票'],
      btnCount: 0,

      form: {
        mytodoId: '',
        custId: '',
        notes: '',
        fileList: [],
        fileNotes: [],
        checkList:[],
        timeHour:0,
        timeMinute:0,
        uploadedFile:'',
        defaultItem: '',
        product:''
      },

      rules: {
        title: [{validator: checkName, trigger: 'change'}],
        startDate: [{validator: checkName, trigger: 'change'}]
      },
      visitRules: {
        notes: [{required:true, validator: checkName, trigger: 'change'}]
      },
      visitFormRules: {
        custId: [{required: true, validator: checkName, trigger: 'change'}],
        arrivalTime: [{required: true, validator: checkName, trigger: 'change'}],
        customerRecord: [{required: true, validator: checkName, trigger: 'blur'}]
      },
      taskFormRule:{
        notes: [{required:true, validator: checkName, trigger: 'change'}]
      },
      dailyJobRule: {
        product: [{required: true, validator: checkName, trigger: 'change'}],
        qty: [{required: true, validator: checkName, trigger: 'blur'}],
        result: [{required: true, validator: checkName, trigger: 'blur'}],
        progress: [{required: true, validator: checkName, trigger: 'blur'}]
      }
    }
  },
  computed: {
    ...mapState('login', ['userInfo']),
    canEdit() {
      return this.basicForm.status === 'draft' || this.basicForm.status === 'reject'
    },
    canViewSignOff() {
      return this.basicForm.status === 'reject' || this.basicForm.status === 'close'
    },
    
  },
  methods: {
    
    clearInputForm() {
      this.$refs['painting_daily_form'].resetFields()
    },

    cancelAddTask() {
      this.clearInputForm()

      this.editTask = false
      this.$nextTick(()=>{
        document.getElementById("add_task_btn").scrollIntoView({behavior: 'smooth', inline:'nearest'})
      })
    },
    
    
    querySearch(str, cb){
      this.request.get("/product/query?keyword=" + str).then(res => {
        if (res.code === '200') {
          let list = res.data.map((item) => {
            return {
              value: item.model + item.name,
              id: item.id
            }
          })
          cb(list)
        }
      })
    },

    handleSelect(item) {
      // this.form.custId = item.id
      this.form.product = item.value
    },
    
    
    handleSubmitForm() {
      this.request.post("/todo", this.basicForm).then(res => {
        //console.log(res)
        if (res.code === '200') {
          this.formDefault()
          this.showResult('success', '資料更新成功.')
        } else {
          this.showResult('error', '資料更新失敗.')
        }
      })
    },
    handleTaskEdit(rowData) {
      console.log("edit:", rowData)
      this.editTask = true
      this.task.form = rowData
      this.task.form.fileList = []
      this.task.form.fileNotes = []
      this.task.form.fileListDisplay = []
      this.btnCount = 0
    },

    handleDraft() {
      this.handleSubmitForm()
    },

    handleSign() {
      this.$confirm('資料填寫已完成，按下「確定」後將呈主管簽核?', '提醒', {
            confirmButtonText: '確定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.basicForm.status = "review"
            this.request.post("/todo/signoff", this.basicForm).then(res => {
              if (res.code === '200') {
                this.showResult('success', '表單送簽核成功')
                this.$nextTick(()=>{
                    this.goBack()
                 })
              } else {
                this.showResult('error', '表單送簽核失敗')
              }
            })
          }).catch(() => {

          });
    },


    handleAddTask() {

      this.editTask = true
      this.form.id = null
      this.form.fileList = []
      this.form.fileNotes = []
      this.btnCount = 0

      

      this.$nextTick(()=>{
        document.getElementById("add_task_form").scrollIntoView({behavior: 'smooth', inline:'nearest'})
      })

      
    },  

    //為了在更新時，checkbox可以立即生廠，需先改變其它元件
    changeEffect(item) {
      console.log(item)
      this.form.qty = this.form.qty + 1
      this.form.qty = this.form.qty - 1
    },

    handleEdit(rowData) {
      console.log('parent handleEdit:', rowData)
      
      this.editTask = true

      this.$nextTick(()=>{
        this.form = rowData
        this.form.defaultItem = rowData.product
        let temp = rowData.result.split(",");
        this.form.checkList = temp
        this.form.fileList = []
        this.form.fileNotes = []
       })
    },
    
    
    saveTask(formName) {
      this.$refs[formName].validate(async valid => {
       
        if (valid) {

            this.form.result = this.form.checkList.join(",")

            this.request.post("/todo/emp/history", this.form).then(res => {
              if (res.code === '200') {

                this.clearInputForm()

                this.editTask = false
                
                //先讓ui重畫之後再呼叫
                this.$nextTick(()=>{
                  this.$refs['paintingTaskChild'].loadHistoryData()
                  document.getElementById("add_task_btn").scrollIntoView({behavior: 'smooth', inline:'nearest'})
                })
                

                this.showResult('success', '資料更新成功')

                this.editTask = false
              } else {
                this.showResult('error', res.message)
              }
            })
        }
      });
    },
    
    setDialogWidth() {
      let windowSize = document.body.clientWidth;
      const defaultWidth = 400; // 預設寬度
      if (windowSize < defaultWidth) {
        this.dw = "90%";
      } else {
        this.dw = "40%";
      }
    },
    formDefault() {
      this.request.get("/todo/" + this.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.basicForm = res.data
        } else {
          this.showResult('error', '撈資料失敗')
        }
      })
      this.form.userId = this.userInfo.id
    },
    getTodoType() {
      this.userInfo.id;
    },
    
    goBack() {
      this.$router.push('/daily/todo')
    },
    
    loadDicSetting(type) {
      let req = '/dic/type?queryField=' + type
      this.request.get(req).then(res => {
        if (res.code === '200') {
          this.task.paintingTypeOptions = res.data
        }
      })
    },

  },
  filters: {
    signResult(value) {
      if (value === 'N') return '退回'
      if (value === 'Y') return '同意'
      if (value === 'cancel') return '取消'
    }
  },
  mounted() {
    this.form.mytodoId = this.$route.params.mytodoId
    this.task.form.mytodoId = this.$route.params.mytodoId


    this.loadDicSetting('painting_type')

    
    this.formDefault()
    
    this.setDialogWidth();
  }
}
</script>

<style scoped>
.el-table {
  border-radius: 10px;
  padding: 20px;
}

.el-table >>> .headerStyle {
  /*background-color: #1e8fc6;*/
}

.el-popover.el-popper .el-popconfirm {
  background-color: black !important;
  padding: 10px !important;
}

.avatar-uploader {
  /*border: 1px dashed #d9d9d9;*/
  /*border-radius: 6px;*/
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.display-avatar {
  width: 60px;
  height: 60px;
  border-radius: 999px;
}


/deep/ .el-upload-dragger {
  width: 180px !important;
}

.myform >>> .el-form-item__label {
  padding: 0;
}

.el-main {
  padding: 0;
}
.el-form-item {
  margin-bottom: 12px;
}

.taskMain >>> .el-card__body {
  padding: 0 4px;
}
.el-table {
  padding: 0;
}

.el-form--label-top .el-form-item__label {
  padding: 0;
}
.el-autocomplete {
  width: 100%;
}
.el-card__body {
  padding: 20px 0 !important;
}

</style>
